import script from "./CategoryBlogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryBlogModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryBlogModal.vue?vue&type=style&index=0&id=a9385b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9385b54"]])

export default __exports__